module.exports = (self) => {
    $(self).find('[data-toggle="tooltip"]').tooltip();
    $(self).on('mouseup', '.disable-on-submit', function () {
        setTimeout(() => $(this).attr('disabled', 'disabled'), 1);
    });
};



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/stylers/sci.js